<template>
	<div class="default-switch">
		<input class="default-switch__input" :id="id" v-model="value" type="checkbox">
		<label class="default-switch__label" :for="id"></label>
		<span class="default-switch__text" v-if="label">{{ label }}</span>
	</div>
</template>

<script>

export default {
	name: "InputSwitch",
	props: {
		modelValue: {
			type: Boolean,
			default: false
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		}
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	},

}
</script>